export const skillsData = {
    categories: [
      {
        name: "Backend",
        icon: "Server",
        color: "blue",
        skills: ["Spring Boot", "Java", "API REST", "Microservices"]
      },
      {
        name: "Frontend",
        icon: "Laptop",
        color: "green",
        skills: ["React JS", "React Native", "JavaScript / TypeScript", "CSS / Tailwind"]
      },
      {
        name: "DevOps",
        icon: "Cloud",
        color: "orange",
        skills: ["Docker", "CI/CD", "Cloud (Azure)", "VPS"]
      }
    ],
    // skillBars: [
    //   { name: "Spring Boot", percentage: 75, color: "blue" },
    //   { name: "React JS", percentage: 60, color: "green" },
    //   { name: "React Native", percentage: 70, color: "cyan" },
    //   { name: "Docker", percentage: 75, color: "orange" },
    //   { name: "CI/CD", percentage: 60, color: "red" },
    //   { name: "VPS", percentage: 60, color: "purple" }
    // ]
  };